/**
 * Dual-pane layout (`screen_height` sidebar): main column scrolls; sidebar may use an inner
 * scroll region (`[data-sidebar-scroll]`) for nav only. Forward wheel/trackpad to main when
 * that region (or the column) has nowhere left to scroll.
 */
(function () {
  var MQ_DESKTOP = '(min-width: 990px)';
  var EPS = 2;

  function deltaYPixels(e) {
    switch (e.deltaMode) {
      case 1:
        return e.deltaY * 16;
      case 2:
        return e.deltaY * (window.innerHeight || 1);
      default:
        return e.deltaY;
    }
  }

  function shouldForwardScroll(scrollEl, deltaY) {
    var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    if (maxScroll <= EPS) return true;

    var top = scrollEl.scrollTop;
    if (deltaY < 0 && top <= EPS) return true;
    if (deltaY > 0 && top >= maxScroll - EPS) return true;
    return false;
  }

  function init() {
    var sidebarColumn = document.querySelector('#mainGridWrapper > .main-site-grid--sidebar');
    var main = document.querySelector('#mainGridWrapper > .main-site-grid--container');
    if (!sidebarColumn || !main) return;

    var mq = window.matchMedia(MQ_DESKTOP);

    sidebarColumn.addEventListener(
      'wheel',
      function (e) {
        if (!mq.matches) return;
        if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;

        var dy = deltaYPixels(e);
        if (dy === 0) return;

        var scrollEl =
          sidebarColumn.querySelector('[data-sidebar-scroll]') || sidebarColumn;
        if (!shouldForwardScroll(scrollEl, dy)) return;

        e.preventDefault();
        main.scrollTop += dy;
      },
      { passive: false }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
